import { ToggleButtonWebElementBase } from './ToggleButtonWebElementBase';

/**
 * The component WebElement for [oj-c-toggle-button](../../jsdocs/oj-c.ToggleButton.html).
 * Do not instantiate this class directly, instead, use
 * [findToggleButton](../functions/findToggleButton.html).
 */
export class ToggleButtonWebElement extends ToggleButtonWebElementBase {
  // Put overrides here
}
